import { render, staticRenderFns } from "./EmailAutomations.vue?vue&type=template&id=dfcca9dc"
import script from "./EmailAutomations.vue?vue&type=script&lang=js"
export * from "./EmailAutomations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports